module.exports = __webpack_public_path__ + "img/pic_zb_d5.9a8ade48.png";